import React, { useContext, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Icon, Radio } from 'semantic-ui-react';
import { useCreateUserIn2n } from 'services/2n/create-user';
import { useGetUserIn2n } from 'services/2n/get-user';
import { useUpdateUserIn2n } from 'services/2n/update-user';
import { useModal } from 'store/modals';
import { useUpdateUserPermissions } from 'services/user/update-permissions';
import { useUserPermissionsByEmail } from 'services/user/permissions/permissions-by-email';
import { Text } from '../../../../../../../../../typography';
import { Grid } from '../../../../../../../../../layout/Grid';
import { UserAdministrationModalContext } from '../../../../UserAdministrationModalContext';
import styles from './styles.module.scss';

export function ManageAccessToServices() {
  const intl = useIntl();

  const {
    selectedUser,
    isPrimaryResidentAddress,
    setService,
  } = useContext(UserAdministrationModalContext);
  const userPermissionsByEmail = useUserPermissionsByEmail(selectedUser && selectedUser.email);

  const { openModal } = useModal();

  const updateUserPermissions = useUpdateUserPermissions({ selectedUser });
  const handlePrimaryResidentChange = () => {
    openModal({
      modalType: 'ConfirmationModal',
      modalProps: {
        title: intl.formatMessage({ id: 'changePrimaryResidentAddress' }),
        content: intl.formatMessage({
          id: 'changePrimaryResidentAddressContent',
        }, {
          selectedUserEmail: <strong>{selectedUser.email}</strong>,
          aptId: <strong>{selectedUser.addressId}</strong>,
        }),
        onConfirm: async () => {
          await updateUserPermissions.mutateAsync({
            userEmail: selectedUser.email,
            permissions: {
              'admin-address': {
                read: true,
              },
            },
          });
        },
      },
    });
  };

  const getUserIn2N = useGetUserIn2n(selectedUser && selectedUser.email);
  const createUserIn2N = useCreateUserIn2n(selectedUser);
  const updateUserIn2N = useUpdateUserIn2n(getUserIn2N.user);

  const [hasUserAccessTo2N, setHasUserAccessTo2N] = React.useState(false);

  useEffect(() => {
    setHasUserAccessTo2N(getUserIn2N?.user && !getUserIn2N.isSuspended);
  }, [getUserIn2N]);

  return (
    <Grid
      noPadding
      oneColumn
      className={styles.servicesContainer}
      justifyItems="start"
    >
      <Text
        size={20}
        fontWeight={700}
      >
        {intl.formatMessage({ id: 'accessToServices' })}
      </Text>

      <div className={styles.services}>
        <div className={`${styles.service} ${styles.centered}`}>
          {
            isPrimaryResidentAddress && !(userPermissionsByEmail && userPermissionsByEmail.isLoading) ? (
              <>
                <Text>
                  <FormattedMessage
                    id="userIsPrimaryResident"
                    values={{ aptId: <strong> {selectedUser && selectedUser.addressId} </strong> }}
                  />
                </Text>
                <div />
              </>
            ) : (
              <>
                <Text>
                  <FormattedMessage
                    id="userIsNotPrimaryResident"
                    values={{ aptId: <strong> {selectedUser && selectedUser.addressId} </strong> }}
                  />
                </Text>
                <Button
                  className={styles.deleteBtn}
                  onClick={() => handlePrimaryResidentChange()}
                >{intl.formatMessage({ id: 'reassignPrimaryResident' })}
                </Button>
              </>
            )
          }
        </div>
        <div className={styles.service}>
          <Radio
            label={intl.formatMessage({ id: 'accessControl2n' })}
            toggle
            name="accessControl2n"
            checked={hasUserAccessTo2N}
            disabled={getUserIn2N.isLoading || updateUserIn2N.isLoading}
            onChange={(event, value) => {
              openModal({
                modalType: 'ConfirmationModal',
                modalProps: {
                  title: intl.formatMessage({ id: 'createUserIn2n' }),
                  content: intl.formatMessage({ id: 'createUserIn2nContent' }),
                  onConfirm: async () => {
                    if (!getUserIn2N.user) {
                      await createUserIn2N.mutateAsync(selectedUser);
                    } else {
                      updateUserIn2N.mutate({ isSuspended: !value.checked });
                    }
                  },
                },
              });
            }}
          />

          {hasUserAccessTo2N && (
          <div className={styles.configureService}>

            <Button
              basic
              icon
              labelPosition="right"
              color="primary"
              onClick={() => {
                setService('2N Access Control');
              }}
            >
              <FormattedMessage id="configure" />
              <Icon name="pencil alternate" />
            </Button>

            <Text red>
              <FormattedMessage
                id="setupRequired"
              />
            </Text>

          </div>
          )}

        </div>

      </div>
    </Grid>
  );
}
